export enum OrderSocketMessage {
	CHECK = 'check',
	CUSTOMER = 'customer',
	USER = 'user',
	VENUE = 'venue',
	PAYTRANSACTION = 'initPayTransaction',
	DEVICEMESSAGE = 'sendDeviceMessage',
}
